import { AudioVideoIcon } from './AudioVideoIcon';

/**
 * author: Michael Richins
 * id 79CBF0E5-365C-466B-B162-2EBD1531F182
 * name audio-video
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/audio-video.svg
 * tags
 * - Home Automation 
 * - Audio 
 */
export const AvReceiverIcon = AudioVideoIcon;
export default AvReceiverIcon